<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     工时结算
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="kpi-workorder header-padding">
    <f-page-header />

    <div class="filter-container">
      <div class="filter-box">
        <span class="filter-item">
          <f-radio-btn-group v-model="query.status" :groups="radios" type="arrow" @change="fetchData(1)" />
        </span>

        <span class="filter-item lg">
          <f-date-range-picker v-model="query.endtime" @change="fetchData(1)" />
        </span>

        <span class="filter-item sm">
          <pp-station-selector v-model="query.stationid" placeholder="选择工位" @change="fetchData(1)" />
        </span>

        <span class="filter-item sm">
          <f-search-input v-model="query.keyword" @change="fetchData(1)" />
        </span>
      </div>
    </div>

    <el-card v-loading="loading" class="table-card" shadow="never">
      <el-table ref="listTable" :data="list" size="medium" class="padding-small" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="60"></el-table-column>

        <el-table-column label="工单号/内容" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link :underline="false" class="link-class" @click="toDetail(scope.row.workorderid)">
              <div class="flex align-items-center">
                  <div class="text-muted order-no">{{ scope.row.workorder_no}}</div>
                  <icon-svg v-if="scope.row.type == 1" icon-class="maintask" style="font-size: 22px"/>
                  <icon-svg v-else-if="scope.row.type == 2" icon-class="subtask" style="font-size: 22px"/>
              </div>
              <div class="ellipsis">{{ scope.row.workorder_title}}</div>
            </el-link>
          </template>
        </el-table-column>

        <el-table-column label="工位" min-width="90">
          <template slot-scope="scope">
            <el-link v-if="scope.row.create_from === 0" :underline="false">
              <span @click="toWorkstationDetail(scope.row)">{{ scope.row.station_title }}</span>
            </el-link>
            <el-tag v-else type="warning" effect="plain" size="small">自建工单</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" min-width="220" show-overflow-tooltip>
          <template slot="header">
            <div class="k-t-header">
              <div class="k-top">派工信息</div>
              <div class="k-bottom">
                <span class="k-item">数量</span>
                <span class="k-item">额定工时</span>
                <span class="k-item">附加工时</span>
                <span class="k-item">派工工时</span>
              </div>
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.create_from === 0" class="k-bottom text-bold number">
              <span class="k-item">
                <span>{{ scope.row.plan_num }}</span>
              </span>
              <span class="k-item">
                <span>{{ scope.row.standard_hour }}</span>
                <span class="text-muted">{{ scope.row.standard_unit }}/件</span>
              </span>
              <span class="k-item">
                <span>{{ scope.row.add_hour }}</span>
                <span class="text-muted">{{ scope.row.standard_unit }}</span>
              </span>
              <span class="k-item">
                <span>{{ scope.row.plan_total_hour }}</span>
                <span class="text-muted">{{ scope.row.standard_unit }}</span>
              </span>
            </div>
            <div v-else class="k-bottom text-bold number">
              <span class="k-item">
                <span>--</span>
              </span>
              <span class="k-item">
                <span>--</span>
              </span>
              <span class="k-item">
                <span>--</span>
              </span>
              <span class="k-item">
                <span>--</span>
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作/完工时间" min-width="120">
          <template slot-scope="scope">
            <div class="flex">
              <div v-if="scope.row.users && scope.row.users.length">
                <f-user-avatar :user="scope.row.users[0]"></f-user-avatar>
              </div>

              <div class="ml-sm">
                <div v-if="scope.row.users && scope.row.users.length">
                  <span :class="scope.row.users[0].username ? '' : 'text-danger'">{{ scope.row.users[0].username || "该用户已被删除" }}</span>
                  <span v-if="scope.row.users.length > 1">等{{ scope.row.users.length }}人</span>
                  <el-tooltip v-if="scope.row.report_remark" :content="scope.row.report_remark" placement="top">
                    <i class="ml el-icon-chat-dot-round"></i>
                  </el-tooltip>
                </div>
                <div class="text-muted">{{ scope.row.endtime | parseTime('{y}-{m}-{d} {h}:{i}') }}</div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" min-width="160">
          <template slot="header">
            <div class="k-t-header">
              <div class="k-top">报工信息</div>
              <div class="k-bottom">
                <div class="k-item">合格数</div>
                <div class="k-item">不合格数</div>
                <div class="k-item">工时</div>
              </div>
            </div>
          </template>
          <template slot-scope="scope">
            <el-popover placement="right" width="600" trigger="hover">
              <el-table
                ref="membersTable"
                :data="scope.row.users ? scope.row.users : []"
                tooltip-effect="dark"
                class="padding-small"
                style="width: 100%"
                max-height="500"
              >
                <el-table-column type="index" label="#" width="40" />

                <el-table-column label="用户" width="60">
                  <template slot-scope="item">
                    <f-user-avatar :user="item.row"></f-user-avatar>
                  </template>
                </el-table-column>

                <el-table-column min-width="60" show-overflow-tooltip>
                  <template slot-scope="item">
                    <span :class="item.row.username ? '' : 'text-danger'">{{item.row.username || "该用户已被删除"}}</span>
                  </template>
                </el-table-column>

                <el-table-column label="报工工时" min-width="100" show-overflow-tooltip align="center">
                  <template slot-scope="item">
                    <span class="number font-16 text-bold">{{item.row.report_hour}}</span>
                    <span class="font-13 text-muted">{{scope.row.standard_unit}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="结算工时" min-width="100" show-overflow-tooltip align="center">
                  <template slot-scope="item">
                    <span v-if="scope.row.status == 100" class="number font-16 text-bold">{{item.row.confirm_hour}}</span>
                    <span v-if="scope.row.status == 100" class="font-13 text-muted">{{scope.row.standard_unit}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
              </el-table>

              <div slot="reference" class="pt pb">
                <div class="k-bottom text-bold number">
                  <span class="k-item">
                    <span>{{ scope.row.non_defective_num }}</span>
                  </span>
                  <span class="k-item" :class="parseInt(scope.row.defective_num) >= 1? 'text-danger': 'text-muted'">{{ scope.row.defective_num }}</span>
                  <span class="k-item">
                    <span :class="scope.row.status == 90 ? 'text-warning' : ''">
                      {{ scope.row.report_total_hour }}
                      <span :class="scope.row.status == 90 ? '' : 'text-muted'">
                        {{ scope.row.standard_unit }}
                        <i
                          v-if="scope.row.status == 100&&scope.row.confirm_total_hour != scope.row.report_total_hour"
                          class="el-icon-warning-outline"
                        />
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column label="审批/结单时间" min-width="120">
          <template slot-scope="scope">
            <div class="flex" v-if="scope.row.confirmer">
              <div>
                <f-user-avatar :user="scope.row.confirmer"></f-user-avatar>
              </div>
              <div class="ml-sm" style="flex: 1">
                <f-user-name :user="scope.row.confirmer"></f-user-name>
                <el-tooltip v-if="scope.row.confirm_remark" :content="scope.row.confirm_remark" placement="top">
                  <i class="ml el-icon-chat-dot-round"></i>
                </el-tooltip>
                <div class="text-muted">{{ scope.row.confirm_time | parseTime('{y}-{m}-{d} {h}:{i}') }}</div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 100">
              <span class="text-muted hover-hide">已结单</span>
              <el-button class="hover-show" type="text" @click="showSingle(scope.row)">修改</el-button>
            </span>
            <el-button v-else type="text" @click="showSingle(scope.row)">结单</el-button>
          </template>
        </el-table-column>

        <template slot="empty">
          <img class="image huger mt-lg" src="@/assets/empty.png" />
          <div class="font-md mb-hg">暂无数据</div>
        </template>
      </el-table>
      <el-dialog
        :visible.sync="dialogVisible"
        title="批量结单"
        width="460px"
        style="top: 16vh"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
      >
        <div class="mb">
          将结算选中的
          <span class="number text-success font-20">{{ multiSelection.length }}</span> 条记录，是否继续？
        </div>
        <el-radio v-model="confirmType" label="report">按报工工时结算</el-radio>
        <el-radio v-model="confirmType" label="plan">按派工工时结算</el-radio>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="batchWorkorder">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>

    <f-table-footer
      checkbox
      :list="list"
      :selection="multiSelection"
      @toggle="toggleAll"
      :total="total"
      :pindex.sync="query.pindex"
      :psize.sync="query.psize"
      @change="fetchData"
    >
      <template slot="left">
        <el-tooltip content="请切换至待结单状态" placement="top" :disabled="(query.status == 1)">
          <span>
            <el-button plain :disabled="isAllow" size="mini" @click="batch">结单</el-button>
          </span>
        </el-tooltip>
        <el-button class="ml" plain size="mini" @click="exportD">导出</el-button>
      </template>
    </f-table-footer>
    <div>
      <single-statement v-if="single" :show.sync="single" :workorderid="workorderid" @success="fetchData" @hide="close"></single-statement>
      <WorkOrderSplit
        v-else-if="split"
        :split.sync="split"
        :workorderid="workorderid"
        @success="fetchData"
        @hideShow="closeDialog"
        @hide="closeSplit"
      />
    </div>
  </div>
</template>

<script>
import { userOrderApi, batchWorderApi, exportWOApi } from "@/api/kpi/kpiApi";
import WorkOrderSplit from "./components/WorkOrderSplit.vue";

export default {
  name: "KpiWorkorder",

  components: {
    MesNumSelector: () => import("../mes/components/MesNumSelector.vue"),
    PpStationSelector: () => import("../pp/components/PpStationSelector.vue"),
    SingleStatement: () => import("@/views/kpi/components/SingleStatement"),
    WorkOrderSplit
  },

  data() {
    return {
      loading: false,
      dialogVisible: false,
      confirmType: "report",
      query: {
        keyword: "",
        status: 0,
        stationid: "",
        endtime: null,
        pindex: 1,
        psize: this.$store.state.commonStore.psize
      },
      total: 0,
      workorderid: null,
      single: false,
      split: false,
      uploadShow: false,
      multiSelection: [],
      radios: [
        { value: 0, title: "全部", separate: true },
        { value: 1, title: "待结单" },
        { value: 2, title: "已结单" }
      ],
      list: [],

      query2: {
        keyword: "",
        pindex: 1,
        psize: this.$store.state.commonStore.psize
      },
      list2: [],
      total2: 0,
      loading2: false
    };
  },
  computed: {
    isAllow() {
      let x = false;
      if (this.multiSelection.length) {
        this.multiSelection.forEach(item => {
          if (item.status == 100) {
            x = true;
          }
        });
        return x;
      } else {
        return !x;
      }
    }
  },

  created() {
    this.fetchData(1);
  },

  methods: {
    fetchData(pindex) {
      if (pindex) this.query.pindex = pindex;
      this.loading = true;
      userOrderApi(this.query).then(res => {
        this.loading = false;
        if (!res.errno) {
          this.list = res.data.list;
          this.total = res.data.total;
        }
      });
    },

    fetchWorkstationData(page, loading = true) {
      if (page) this.query2.pindex = page;
      if (loading) this.loading2 = true;
      getStationListApi(this.query2).then(res => {
        this.loading2 = false;
        if (!res.errno) {
          this.list2 = res.data.list;
          this.list2.forEach(item => {
            item.binder = item.operators.concat(item.inspectors);
          });
          this.total2 = res.data.total;
        }
      });
    },

    toDetail(id) {
      this.$detail(id);
    },

    toWorkstationDetail(row) {
      const { stationid } = row;
      const _this = this;
      this.$sdetail({
        stationid,
        handleChange: () => {
          _this.fetchWorkstationData();
        }
      });
    },

    openUpload() {
      this.uploadShow = true;
    },

    handleSelectionChange(val) {
      this.multiSelection = val;
    },

    toggleAll() {
      this.$refs.listTable.toggleAllSelection();
    },

    showSingle(item) {
      this.workorderid = item.workorderid;
      this.single = true;
    },
    batch() {
      this.dialogVisible = true;
    },

    batchWorkorder() {
      let workorderids = this.multiSelection.map(item => {
        return item.workorderid;
      });
      batchWorderApi({
        workorderids: workorderids,
        type: this.confirmType
      }).then(res => {
        if (!res.errno) {
          this.fetchData();
          this.dialogVisible = false;
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    exportD() {
      // 增加loading
      this.loading = true;
      exportWOApi(this.query).then(res => {
        this.loading = false;
        if (!res.errno) {
          window.open(res.data.url);
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    close() {
      this.single = false;
      this.split = true;
    },
    closeSplit() {
      this.split = false;
    },
    closeDialog() {
      this.split = false;
      this.single = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.kpi-workorder {
  position: relative;

  .k-t-header {
    position: relative;
    width: 100%;

    .k-top {
      height: 22px;
      line-height: 22px;
      text-align: center;
      border-bottom: 1px solid #cccccc;
    }
  }

  .k-bottom {
    position: relative;
    display: flex;
    align-items: center;

    .k-item {
      flex: 1;
      text-align: center;
      height: 21px;
      line-height: 21px;
    }
  }

  .order-no:hover {
    color: #07c160;
  }

  .link-class {
    width: 100%;
    /deep/.el-link--inner {
      width: 100%;
    }
  }
}
</style>
